import script from "./ModalDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ModalDialog.vue?vue&type=style&index=0&id=300a00e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300a00e4"]])

export default __exports__